import {
	PropsWithChildren,
	MouseEvent,
	useCallback,
	KeyboardEvent
} from "react";
import { useListItemContext } from "client/Components";
import styles from "./DocumentLocation.module.less";
import { tryResolveKeyboardKey } from "client/Misc/keyboardUtils";
import { Key } from "client/Misc/commonTypes";

type DocumentLocationProps = {
	onClick: () => void;
};

export const DocumentLocation = (props: PropsWithChildren<DocumentLocationProps>) => {
	const {
		onClick,
		children
	} = props;

	const { hasFocusVisible } = useListItemContext();

	const clickHandler = useCallback(
		(event: MouseEvent): void => {
			event.preventDefault();
			event.stopPropagation();
			onClick();
		},
		[onClick]
	);

	const keyDownHandler = useCallback(
		(args: KeyboardEvent<HTMLSpanElement>): void => {
			const key: Key | null = tryResolveKeyboardKey(args);

			switch (key) {
				case Key.Enter:
				case Key.Space:
					args.preventDefault();
					args.stopPropagation();
					onClick();
					break;
				default:
					// Do nothing
			}
		},
		[onClick]
	);

	return (
		<span
			className={styles.root}
			onClick={clickHandler}
			onKeyDown={keyDownHandler}
			tabIndex={hasFocusVisible ? 0 : -1}
		>
			{children}
		</span>
	);
};
DocumentLocation.displayName = "DocumentLocation";